import {type DiscordSDK, RPCErrorCodes} from '@discord/embedded-app-sdk'
import {type TranslationObject} from '@colonist/i18n'
import {UIPopupController} from '../../../../../shared/scripts/ui_popup/UIPopupController.ts'
import {DiscordMountContentFrameDispatcher} from './DiscordMountContentFrameDispatcher.ts'

export class DiscordMountSDKCommandDispatcher {
    private readonly discordSDK: DiscordSDK

    constructor(discordSDK: DiscordSDK) {
        this.discordSDK = discordSDK
    }

    async handleCommand<T extends keyof DiscordSDK['commands']>(command: T, data: Parameters<DiscordSDK['commands'][T]>): Promise<ReturnType<DiscordSDK['commands'][T]> | undefined> {
        try {
            return (await this.discordSDK.commands[command].apply(null, data as any)) as any
        } catch(err) {
            if(err.code == RPCErrorCodes.INVALID_COMMAND) {
                // Expected error. Command not supported on Discord Client
                DiscordMountSDKCommandDispatcher.handleInvalidCommandError()
                return undefined
            }

            const userCanceledPurchaseCode = 5008
            if(err.code == userCanceledPurchaseCode) return undefined

            const userAlreadyHasMembershipCode = 5009
            if(err.code == userAlreadyHasMembershipCode) {
                DiscordMountContentFrameDispatcher.notifyUserAlreadyHasMembershipError(err)
                return undefined
            }

            DiscordMountSDKCommandDispatcher.handleUnexpectedError(err)
            return undefined
        }
    }

    private static handleInvalidCommandError() {
        const invalidCommandTitle: TranslationObject = {key: 'strings:popups.errors.discordUpdateClient.title'}
        const invalidCommandBody: TranslationObject = {key: 'strings:popups.errors.discordUpdateClient.body'}
        UIPopupController.createSimplePopup(invalidCommandTitle, invalidCommandBody)
    }

    private static handleUnexpectedError(err: any) {
        const unexpectedErrorTitle: TranslationObject = {key: 'strings:popups.errors.discordCommandUnexpectedError.title'}
        const unexpectedErrorBody: TranslationObject = {key: 'strings:popups.errors.discordCommandUnexpectedError.body', options: {error: err.message}}
        UIPopupController.createSimplePopup(unexpectedErrorTitle, unexpectedErrorBody)
    }
}
